import request from '../../../axios';

export const getChat = async (params: string) => {
  const {data}: {data: IGetChatResponse} = await request.get(
    `/api/v2/shop/get-chat?supplier_guid=` + params,
  );
  return data;
};
